import React, { useState } from "react";
import ButtonList from "../ButtonList/ButtonList";
import { Tab, Nav, Tabs } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import { IoClose } from "react-icons/io5";
import SupportPopup from "../SupportPopup/SupportPopup";
import { useContext } from "react";
import { VideoContext } from "../../videoContext";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, Autoplay } from 'swiper/modules';

function ClubOurProcess() {

  const { currentPlayingIndex, setCurrentPlayingIndex, handlePlay, playVideo, pauseVideo, playerRefs } = useContext(VideoContext);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const videos = [
    {
      id: 1,
      eventKey: 'first',
      step: 'Foreward Irons',
      title: 'Low Bounce',
      url: "https://player.vimeo.com/video/897992371?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0",
      name: 'Low Bounce',
      description: '2 degrees of bounce with a pre worn leading edge, with a moderate sole width. Matching up sole to swing dynamics to promote ',
    },
    {
      id: 2,
      eventKey: 'second',
      step: 'Foreward Irons',
      title: 'Mid Bounce',
      url: 'https://player.vimeo.com/video/897992499?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0',
      name: 'Medium Bounce',
      description: '4.5 degrees of bounce with a pre worn leading edge, with a moderate sole width. Matching up sole to swing dynamics to promote ',
    },
    {
      id: 3,
      eventKey: 'third',
      step: 'Foreward Irons',
      title: 'High Bounce',
      url: 'https://player.vimeo.com/video/897992285?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0',
      name: ' High Bounce',
      description: '7 degrees of bounce with a pre worn leading edge, with a moderate sole width. Matching up sole to swing dynamics to promote ',
    },

  ];


  const tabKeys = ['first', 'second', 'third'];
  const [activeTab, setActiveTab] = useState(tabKeys[0]);



  const handleTabChange = (eventKey) => {
    setActiveTab(eventKey);
  };

  const handleNextTab = () => {
    const currentIndex = tabKeys.indexOf(activeTab);
    if (currentIndex < tabKeys.length - 1) {
      setActiveTab(tabKeys[currentIndex + 1]);
    }
  };

  const handlePrevTab = () => {
    const currentIndex = tabKeys.indexOf(activeTab);
    if (currentIndex > 0) {
      setActiveTab(tabKeys[currentIndex - 1]);
    }
  };


  return (
    <>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        id="success_tic"
        className="center-form-modal"
      >
        <Modal.Body>
          <div className="custom-modal-header">
            <h3 className="text mb-5">How can we help?</h3>
            <div className="close-modal">
              <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"> <IoClose /></button>
            </div>
          </div>
          <SupportPopup />
        </Modal.Body>
      </Modal>


      <section id="our_process" className="our_process bg_dark page-section">
        <div className="container-xl">
          <div className="d-flex align-items-center justify-content-between sec_tile_bar">
            <h2 className="sec_title">Our Clubs</h2>
            <div className="btn-section hide_mobile">
              <ButtonList subject= "Golf Clubs" />
            </div>
          </div>
          {/* <div className="hide_leptop_v2">
            <div className="row align-items-center custom_md_100">
              <div className="col-lg-6">
                <div className="pr_card">
                  <div className="pr_content club_content">
                    <h6>Foreward Irons</h6>
                    <h4>Low Bounce</h4>
                    <p>2 degrees of bounce with a pre worn leading edge, with a moderate sole width. Matching up sole to swing dynamics to promote <span className="text_color_dark">Tiger Strikes.</span></p>
                  </div>
                  <div className="pr_card_btn">
                    <button className="btn pr_btn_item btn_color_light" onClick={handleShow}>Inquire for custom set</button>
                    <button href="#" className="btn pr_btn_item btn_color_dark">Purchase Iron Heads</button>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                  <div id="v-video" className="v-video">
                    <iframe
                      src="https://player.vimeo.com/video/844432303?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowfullscreen=""
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                      title="Video-1"
                      data-ready="true"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
            <div className="row align-items-center custom_md_100">
              <div className="col-lg-6">
                <div className="pr_card">
                  <div className="pr_content club_content">
                    <h6>Foreward Irons</h6>
                    <h4>Medium Bounce</h4>
                    <p>4.5 degrees of bounce with a pre worn leading edge, with a moderate sole width. Matching up sole to swing dynamics to promote <span className="text_color_dark">Tiger Strikes.</span></p>
                  </div>
                  <div className="pr_card_btn">
                    <button className="btn pr_btn_item btn_color_light" onClick={handleShow}>Inquire for custom set</button>
                    <button href="#" className="btn pr_btn_item btn_color_dark">Purchase Iron Heads</button>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                  <div id="v-video" className="v-video">
                    <iframe
                      src="https://player.vimeo.com/video/844432303?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowfullscreen=""
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                      title="Video-1"
                      data-ready="true"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="pr_card">
                  <div className="pr_content club_content">
                    <h6>Foreward Irons</h6>
                    <h4>High Bounce</h4>
                    <p>2 degrees of bounce with a pre worn leading edge, with a moderate sole width. Matching up sole to swing dynamics to promote <span className="text_color_dark">Tiger Strikes.</span></p>
                  </div>
                  <div className="pr_card_btn">
                    <button className="btn pr_btn_item btn_color_light" onClick={handleShow}>Inquire for custom set</button>
                    <button href="#" className="btn pr_btn_item btn_color_dark">Purchase Iron Heads</button>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                  <div id="v-video" className="v-video">
                    <iframe
                      src="https://player.vimeo.com/video/844432303?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowfullscreen=""
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                      title="Video-1"
                      data-ready="true"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="show_leptop_v2">
            <div className="row">
              <div className="col-lg-4">
                <div className="pr_card">
                  <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                    <div id="v-video" className="v-video">
                      <iframe
                        src="https://player.vimeo.com/video/897992371?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=1"
                        frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowfullscreen=""
                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                        title="Video-1"
                        data-ready="true"
                      ></iframe>
                    </div>
                  </div>
                  <div className="pr_content club_content">
                    <h6>Foreward Irons</h6>
                    <h4>Low Bounce</h4>
                    <p>2 degrees of bounce with a pre worn leading edge, with a moderate sole width. Matching up sole to swing dynamics to promote <span className="text_color_dark">Tiger Strikes.</span></p>
                  </div>
                  {/* <div className="pr_card_btn">
                    <button className="btn pr_btn_item btn_color_light" onClick={handleShow}>Inquire for custom set</button>
                    <button href="#" className="btn pr_btn_item btn_color_dark">Purchase Iron Heads</button>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-4">
                <div className="pr_card">
                  <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                    <div id="v-video" className="v-video">
                      <iframe
                        src="https://player.vimeo.com/video/897992499?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=1"
                        frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowfullscreen=""
                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                        title="Video-1"
                        data-ready="true"
                      ></iframe>
                    </div>
                  </div>
                  <div className="pr_content club_content">
                    <h6>Foreward Irons</h6>
                    <h4>Medium Bounce</h4>
                    <p>4.5 degrees of bounce with a pre worn leading edge, with a moderate sole width. Matching up sole to swing dynamics to promote <span className="text_color_dark">Tiger Strikes.</span></p>
                  </div>
                  {/* <div className="pr_card_btn">
                    <button className="btn pr_btn_item btn_color_light" onClick={handleShow}>Inquire for custom set</button>
                    <button href="#" className="btn pr_btn_item btn_color_dark">Purchase Iron Heads</button>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-4">
                <div className="pr_card">
                  <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                    <div id="v-video" className="v-video">
                      <iframe
                        src="https://player.vimeo.com/video/897992285?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=1"
                        frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowfullscreen=""
                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                        title="Video-1"
                        data-ready="true"
                      ></iframe>
                    </div>
                  </div>
                  <div className="pr_content club_content">
                    <h6>Foreward Irons</h6>
                    <h4>High Bounce</h4>
                    <p>7 degrees of bounce with a pre worn leading edge, with a moderate sole width. Matching up sole to swing dynamics to promote <span className="text_color_dark">Tiger Strikes.</span></p>
                  </div>
                  {/* <div className="pr_card_btn">
                    <button className="btn pr_btn_item btn_color_light" onClick={handleShow}>Inquire for custom set</button>
                    <button href="#" className="btn pr_btn_item btn_color_dark">Purchase Iron Heads</button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="show_mobile_v2">
            {/* <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Nav variant="pills" className="nav nav-tabs process_tabs hide_desktop">
                <Nav.Item className="" style={{ width: '33.333333%' }}>
                  <Nav.Link eventKey="first" className="">
                    Low-Bounce
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="" style={{ width: '33.333333%' }}>
                  <Nav.Link eventKey="second" className="">
                    Medium-Bounce
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="" style={{ width: '33.333333%' }}>
                  <Nav.Link eventKey="third" className="">
                    High-Bounce
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              <>
                <Tab.Content className="row" id="Process_tab_Content">
                  <Tab.Pane eventKey="first" className="tab-pane fade show_desktop col-lg-6">
                    <div className="pr_card">
                      <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                        <div id="v-video" className="v-video">
                          <iframe
                            src="https://player.vimeo.com/video/844432303?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0"
                            frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowfullscreen=""
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                            title="Video-1"
                            data-ready="true"
                          ></iframe>
                        </div>
                      </div>
                      <div className="pr_content club_content">
                        <h6>Foreward Irons</h6>
                        <h4>Low Bounce</h4>
                        <p>2 degrees of bounce with a pre worn leading edge, with a moderate sole width. Matching up sole to swing dynamics to promote <span className="text_color_dark">Tiger Strikes.</span></p>
                      </div>
                      <div className="pr_card_btn">
                        <button className="btn pr_btn_item btn_color_light" onClick={handleShow}>Inquire for custom set</button>
                        <button href="#" className="btn pr_btn_item btn_color_dark">Purchase Iron Heads</button>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second" className="tab-pane fade show_desktop col-lg-6">
                    <div className="pr_card">
                      <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                        <div id="v-video" className="v-video">
                          <iframe
                            src="https://player.vimeo.com/video/844432303?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0"
                            frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowfullscreen=""
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                            title="Video-1"
                            data-ready="true"
                          ></iframe>
                        </div>
                      </div>
                      <div className="pr_content club_content">
                        <h6>Foreward Irons</h6>
                        <h4>Low Bounce</h4>
                        <p>2 degrees of bounce with a pre worn leading edge, with a moderate sole width. Matching up sole to swing dynamics to promote <span className="text_color_dark">Tiger Strikes.</span></p>
                      </div>
                      <div className="pr_card_btn">
                        <button className="btn pr_btn_item btn_color_light" onClick={handleShow}>Inquire for custom set</button>
                        <button href="#" className="btn pr_btn_item btn_color_dark">Purchase Iron Heads</button>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="third" className="tab-pane fade show_desktop col-lg-6">
                    <div className="pr_card">
                      <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                        <div id="v-video" className="v-video">
                          <iframe
                            src="https://player.vimeo.com/video/844432303?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0"
                            frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowfullscreen=""
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                            title="Video-1"
                            data-ready="true"
                          ></iframe>
                        </div>
                      </div>
                      <div className="pr_content club_content">
                        <h6>Foreward Irons</h6>
                        <h4>Low Bounce</h4>
                        <p>2 degrees of bounce with a pre worn leading edge, with a moderate sole width. Matching up sole to swing dynamics to promote <span className="text_color_dark">Tiger Strikes.</span></p>
                      </div>
                      <div className="pr_card_btn">
                        <button className="btn pr_btn_item btn_color_light" onClick={handleShow}>Inquire for custom set</button>
                        <button href="#" className="btn pr_btn_item btn_color_dark">Purchase Iron Heads</button>
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </>
            </Tab.Container>  */}

            <div className="show_mobile_v2 process_tabs club_process_tabs mobile_process_tabs mb-0">

              <Tabs activeKey={activeTab} onSelect={handleTabChange}>
                {videos.map((video, index) => (
                  <Tab eventKey={video.eventKey} key={index} title={video.title} className="col-lg-4 show_desktop">
                    <div className="" id={`step${video.id + 1}`}>
                      <div className="pr_card">
                        <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                          <div id="v-video" className="v-video">
                            <iframe
                              ref={(ref) => (playerRefs.current[video.id] = ref)}
                              src={video.url}
                              frameborder="0"
                              allow="autoplay; fullscreen; picture-in-picture"
                              allowfullscreen=""
                              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                              title={`Video-${video.id}`}
                              data-ready="true"
                            ></iframe>
                          </div>
                        </div>
                        <div className="pr_content tab-mobile-baar-title">
                          <h6>{video.step}</h6>
                          <h4>{video.name}</h4>
                          <p>{video.description}<span className="text_color_dark">Tiger Strikes.</span></p>
                          <div className="navigation-btn">
                            <button
                              className={`left-navigation-btn navigation-btn-item ${activeTab === tabKeys[0] ? 'disabled' : ''}`}
                              onClick={handlePrevTab}
                            >
                              <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
                                preserveAspectRatio="xMidYMid meet">

                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                  fill="#ffffff" stroke="none">
                                  <path d="M1405 3824 c-47 -25 -1143 -1123 -1167 -1169 -28 -54 -28 -136 0
                                  -190 30 -59 1126 -1150 1174 -1170 176 -72 358 111 279 280 -13 26 -143 163
                                  -380 400 -199 198 -361 363 -361 367 0 5 857 8 1903 8 l1904 0 44 23 c68 36
                                  103 93 107 175 4 81 -21 138 -81 186 l-39 31 -1919 3 c-1055 1 -1919 6 -1919
                                  10 0 4 164 171 365 372 394 394 403 405 393 494 -7 60 -50 130 -100 163 -51
                                  34 -155 43 -203 17z"/>
                                </g>
                              </svg>
                            </button>


                            <button
                              className={`right-navigation-btn navigation-btn-item ${activeTab === tabKeys[tabKeys.length - 1] ? 'disabled' : ''}`}
                              onClick={handleNextTab}
                            >
                              <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
                                preserveAspectRatio="xMidYMid meet">

                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                  fill="#ffffff" stroke="none">
                                  <path d="M3535 3821 c-104 -47 -153 -175 -106 -276 13 -26 143 -163 380 -400
                                    199 -198 361 -363 361 -367 0 -5 -857 -8 -1903 -8 l-1904 0 -44 -23 c-68 -36
                                    -103 -93 -107 -175 -4 -81 21 -138 81 -186 l39 -31 1919 -3 c1055 -1 1919 -6
                                    1919 -10 0 -4 -164 -171 -365 -372 -394 -394 -403 -405 -393 -494 7 -60 50
                                    -130 100 -163 56 -37 148 -44 204 -15 50 26 1145 1124 1170 1172 24 49 23 134
                                    -4 185 -30 59 -1126 1150 -1174 1170 -50 20 -124 19 -173 -4z"/>
                                </g>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                ))}
              </Tabs>
            </div>
          </div>
          <div className="btn-section hide_desktop-v2 mt-4">
            <ButtonList subject= "Golf Clubs"/>
          </div>
        </div>
      </section>


      <section id="image-scroll" className="bg_dark p-0">
        <div className="row">
          <div className="image-scroll">
            <div className="image-scroll-container">
              <Swiper
                modules={[Navigation,Autoplay]}
                centeredSlides={true}
                slidesPerView="auto"
                freeMode={true}
                loop={true}
                mousewheel={{ forceToAxis: true }}
                scrollbar={{ el: '.swiper-scrollbar', hide: true }}
                pagination={{ el: '.swiper-pagination', clickable: true }}
                className="swiper mySwiper_img"
                autoplay={{ delay: 2000, disableOnInteraction: false }}

              >
                <SwiperSlide className="program_w_slide">
                  <div className="image-scroll-item">
                    <img src={require('../../assets/images/image-scroll/IMG_4771.jpg')} alt="image1" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="program_w_slide">
                  <div className="image-scroll-item">
                    <img src={require('../../assets/images/image-scroll/IMG_4772.jpg')} alt="image2" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="program_w_slide">
                  <div className="image-scroll-item">
                    <img src={require('../../assets/images/image-scroll/IMG_4773.jpg')} alt="image3" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="program_w_slide">
                  <div className="image-scroll-item">
                    <img src={require('../../assets/images/image-scroll/IMG_4774.jpg')} alt="image4" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="program_w_slide">
                  <div className="image-scroll-item">
                    <img src={require('../../assets/images/image-scroll/IMG_4977.jpg')} alt="image5" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="program_w_slide">
                  <div className="image-scroll-item">
                    <img src={require('../../assets/images/image-scroll/IMG_5372.jpg')} alt="image6" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="program_w_slide">
                  <div className="image-scroll-item">
                    <img src={require('../../assets/images/image-scroll/IMG_5382.jpg')} alt="image7" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="program_w_slide">
                  <div className="image-scroll-item">
                    <img src={require('../../assets/images/image-scroll/IMG_5651.jpg')} alt="image8" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="program_w_slide">
                  <div className="image-scroll-item">
                    <img src={require('../../assets/images/image-scroll/IMG_5768.jpg')} alt="image9" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="program_w_slide">
                  <div className="image-scroll-item">
                    <img src={require('../../assets/images/image-scroll/IMG_5769.jpg')} alt="image9" />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}

export default ClubOurProcess;

